import { call, put, takeLatest } from "redux-saga/effects";

import { PayloadAction } from "@reduxjs/toolkit";
import { message } from "antd";
import api from "service/apiService";
import { ApiResponse } from "types";
import { translate } from "utils";
import { CarCareCategory } from "../types";
import {
	getCarCareCategorysAsync,
	getCarCareCategoryDetailsAsync,
	GetCarCareCategorysAsyncPayload,
	GetCarCareCategoryDetailsPayload,
	setCarCareCategorys,
	CreateCarCareCategoryPayload,
	createNewCarCareCategoryAsync,
	setCarCareCategory,
	updateCarCareCategoryAsync,
	UpdateCarCareCategoryPayload,
} from "./car-care-category.slice";

// Get list
function* getCarCareCategorysSaga(action: PayloadAction<GetCarCareCategorysAsyncPayload>) {
	const { query, callback } = action.payload;
	const skip = query.skip * (query.take || 0);
	const { response, error } = yield call(async () => {
		try {
			const { data: response } = await api.get<ApiResponse<CarCareCategory[]>>(
				"/dashboard/car-wash-categories",
				{ ...query, skip},
			);
			return { response };
		} catch (error) {
			return { error };
		}
	});
	if (response) {
		callback && callback();
		yield put({ type: setCarCareCategorys.type, payload: response });
	} else {
		message.error(translate(error.message));
	}
}

function* watchGetCarCareCategorys() {
	yield takeLatest(getCarCareCategorysAsync, getCarCareCategorysSaga);
}

// Get carCareCategory details
function* getCarCareCategoryDetailsSaga(action: PayloadAction<GetCarCareCategoryDetailsPayload>) {
	const { id, callback } = action.payload;
	const { response, error } = yield call(async () => {
		try {
			const { data: response } = await api.get<ApiResponse<CarCareCategory>>(
				`/dashboard/car-wash-categories/${id}`,
			);
			return { response };
		} catch (error) {
			return { error };
		}
	});
	if (response) {
		yield put({ type: setCarCareCategory.type, payload: response });
		callback?.(response.data);
	} else {
		message.error(translate(error.message));
	}
}

function* watchCarCareCategoryDetails() {
	yield takeLatest(getCarCareCategoryDetailsAsync, getCarCareCategoryDetailsSaga);
}

// Create new carCareCategory
function* createNewCarCareCategorySaga(action: PayloadAction<CreateCarCareCategoryPayload>) {
	const { data, callback } = action.payload;

	const { response, error } = yield call(async () => {
		try {
			const { data: response } = await api.post("/dashboard/car-wash-categories", data);
			return { response };
		} catch (error) {
			return { error };
		}
	});
	if (response) {
		message.success(translate("Create successful"));
		callback();
	} else {
		message.error(translate(error.message));
	}
}

function* watchCreateCarCareCategory() {
	yield takeLatest(createNewCarCareCategoryAsync, createNewCarCareCategorySaga);
}

// Update part type
function* updateCarCareCategorySaga(action: PayloadAction<UpdateCarCareCategoryPayload>) {
	const { data, id, callback } = action.payload;

	const { response, error } = yield call(async () => {
		try {
			const { data: response } = await api.patch(
				`/dashboard/car-wash-categories/${id}`,
				data,
			);
			return { response };
		} catch (error) {
			return { error };
		}
	});
	if (response) {
		callback && callback();
		message.success(translate("Update successful"));
	} else {
		message.error(translate(error.message));
	}
}

function* watchUpdateCarCareCategory() {
	yield takeLatest(updateCarCareCategoryAsync, updateCarCareCategorySaga);
}





const carCareCategorySaga = [
	watchGetCarCareCategorys(),
	watchCarCareCategoryDetails(),
	watchCreateCarCareCategory(),
	watchUpdateCarCareCategory(),
];
export default carCareCategorySaga;
